(() => {
  const ua = navigator.userAgent || '';
  const isTikTokWebview = /tiktok|musical_ly/i.test(ua);
  if (!isTikTokWebview) return;

  document.documentElement.classList.add('is-tiktok-webview');

  // Zones où un swipe horizontal est "normal" (carrousels/compare sliders).
  // On bloque le geste système de TikTok (retour/fermeture) uniquement dans ces zones.
  const LOCK_SELECTORS = [
    '.flickity-gallery',
    '.flickity-enabled',
    '.before-after-wrapper',
    '[data-tiktok-swipe-lock]',
  ];
  const LOCK_SELECTOR = LOCK_SELECTORS.join(',');

  const isElement = (v) => !!v && typeof v === 'object' && v.nodeType === 1;
  const closestLock = (target) => (isElement(target) ? target.closest(LOCK_SELECTOR) : null);

  let tracking = false;
  let startX = 0;
  let startY = 0;
  let activeLock = null;

  const reset = () => {
    tracking = false;
    startX = 0;
    startY = 0;
    activeLock = null;
  };

  const isEditableTarget = (target) => {
    if (!isElement(target)) return false;
    return !!target.closest('input, textarea, select, [contenteditable="true"], [contenteditable=""], [contenteditable]');
  };

  document.addEventListener(
    'touchstart',
    (e) => {
      if (!e.touches || e.touches.length !== 1) return reset();
      if (isEditableTarget(e.target)) return reset();

      const lock = closestLock(e.target);
      if (!lock) return reset();

      const t = e.touches[0];
      tracking = true;
      activeLock = lock;
      startX = t.clientX;
      startY = t.clientY;
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchmove',
    (e) => {
      if (!tracking || !activeLock) return;
      if (!e.touches || e.touches.length !== 1) return;
      if (isEditableTarget(e.target)) return;
      // Si on sort de la zone lockée, on lâche.
      if (isElement(e.target) && !activeLock.contains(e.target)) return;

      const t = e.touches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      // Ne pas gêner le scroll vertical: on ne bloque que les gestes clairement horizontaux.
      const absX = Math.abs(dx);
      const absY = Math.abs(dy);
      if (absX < 10) return;
      if (absX <= absY + 2) return;

      // Bloque le geste "navigation/fermeture" du webview TikTok.
      if (e.cancelable) e.preventDefault();
    },
    { capture: true, passive: false }
  );

  document.addEventListener('touchend', reset, { capture: true, passive: true });
  document.addEventListener('touchcancel', reset, { capture: true, passive: true });
})();

